import { Component, Vue } from 'vue-property-decorator'
import { getCustomerConversionFollowListByCustomerConversionId }  from '@/api/customer'

@Component({})
export default class FollowRecord extends Vue {
    tableData = []
    page = 1
    limit = 20
    total = 0
    id: number;
    loading = false
    fsnumShow = true

    created() {
        this.$nextTick(() => {
            (this.$refs['el-table'] as HTMLFormElement).bodyWrapper.addEventListener('scroll', (res: any) => {
                const height = res.target;
                const clientHeight = height.clientHeight;
                const scrollTop = height.scrollTop;
                const scrollHeight = height.scrollHeight;
                if (clientHeight + scrollTop >= scrollHeight) {
                    if (this.tableData.length >= this.total) {
                        
                        return
                    }
                    this.limit += 20
                    this.getTableData()
                }
            }, true);
        })
        this.id = Number(this.$route.query.id)
        this.getTableData()
    }

    async getTableData() {
        this.loading = true
        const data: any = await getCustomerConversionFollowListByCustomerConversionId({
            page: this.page,
            limit: this.limit,
            customerConversionId: this.id
        })
        
        this.total = data.allNum
        this.tableData = data.customerConversionFollowList
        // this.tableData = data.customerConversionFollowList.map((item: any) => ({ ...item, createdAt: item.createdAt.split(":")[0], }))
        // const bol = this.tableData.map(item => {
        //     return item.intentionality
        // })
        // if(bol.toString() == '已拒绝'||bol.toString() == '已签约') {
        //     this.fsnumShow = false
        // }
        this.loading = false
    }

    onOpen(url: string) {
        window.open(url, '_blank')
    }
}